export const EXTERNAL_DOCUMENTS = 'ExternalDocuments';